import { NavLink } from "react-router-dom";
import ItodoImage from "../../elements/itodo-img";

function Footer() {
  return (
    <>
      <footer className="site-footer footer-dark">
        {/* FOOTER BLOCKES START */}
        <div className="footer-top">
          <div className="container">
            <div className="row">
              {/* ABOUT COMPANY */}
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div className="widget widget_about">
                  <div className="logo-footer clearfix p-b15">
                    <NavLink to="/" className="sx-text-primary">
                      <div className="bg-light p-1 pb-2">
                        <ItodoImage src="images/Logo-light.png" alt="#" />
                      </div>
                    </NavLink>
                  </div>
                  <p className="pe-5">
                    DArch Tech is a technology-driven digital solutions company
                    specializing in helping businesses build, grow, and scale
                    their online presence effectively. We collaborate closely
                    with startups, SMEs, and enterprises to understand their
                    business objectives, ensuring every solution is strategic,
                    scalable, and performance-focused. Our expertise lies in
                    delivering innovative, secure, and result-oriented digital
                    solutions that drive brand visibility, user engagement, and
                    long-term business growth.
                  </p>
                  <div className="widget_about-call-section">
                    <div className="sx-f-call-icon">
                      <i className="flaticon-telephone" />
                    </div>
                    <div className="sx-f-call-section">
                      <span>Contact us 24/7</span>
                      <a href="tel:+917558307059"> 7558307059 / 9623922545</a>
                    </div>
                  </div>
                </div>
              </div>
              {/* EXPLORE LINKS */}
              <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6 col">
                <div className="widget widget_services">
                  <h4 className="sx-f-title">Explore Links</h4>
                  <ul>
                    <li>
                      <NavLink to="/services">Our Services</NavLink>
                    </li>
                    <li>
                      <NavLink to="/about-us">About US</NavLink>
                    </li>
                    <li>
                      <NavLink to="/pricing">Pricing</NavLink>
                    </li>
                    <li>
                      <NavLink to="/contact-us">Contact</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 col footer-col-3">
                <div className="widget widget_info">
                  <h4 className="sx-f-title">Solutions</h4>
                  <ul>
                    <li>
                      <div className="widget-info-icon">
                        <i className="flaticon-phone" />
                      </div>
                      <div className="widget-info-detail">
                        <a href="tel:+91 7558307059 / 919623922545">
                          Call: +91 7558307059 / +91 9623922545
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="widget-info-icon">
                        <i className="flaticon-email" />
                      </div>
                      <div className="widget-info-detail">
                        <p> admin@darchtech.com </p>
                      </div>
                    </li>
                    <li>
                      <div className="widget-info-icon">
                        <i className="flaticon-maps-and-flags" />
                      </div>
                      <div className="widget-info-detail">
                        <p>
                          Rajdhani Complex, Office No. B/317, 3th Floor, Near
                          Shankar Maharaj Math Pune - Satara Road, Pune-411043
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {/* CONTACT US */}
              {/* <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="widget widget_insta-gallery">
                  <h4 className="sx-f-title">Instagram</h4>
                  <ul>
                    <li>
                      <div className="sx-f-insta">
                        <NavLink to="/gallery">
                          <ItodoImage src="images/f-insta/pic1.jpg" alt="#" />
                          <i className="feather-instagram" />
                        </NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="sx-f-insta">
                        <NavLink to="/gallery">
                          <ItodoImage src="images/f-insta/pic2.jpg" alt="#" />
                          <i className="feather-instagram" />
                        </NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="sx-f-insta">
                        <NavLink to="/gallery">
                          <ItodoImage src="images/f-insta/pic3.jpg" alt="#" />
                          <i className="feather-instagram" />
                        </NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="sx-f-insta">
                        <NavLink to="/gallery">
                          <ItodoImage src="images/f-insta/pic4.jpg" alt="#" />
                          <i className="feather-instagram" />
                        </NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="sx-f-insta">
                        <NavLink to="/gallery">
                          <ItodoImage src="images/f-insta/pic5.jpg" alt="#" />
                          <i className="feather-instagram" />
                        </NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="sx-f-insta">
                        <NavLink to="/gallery">
                          <ItodoImage src="images/f-insta/pic6.jpg" alt="#" />
                          <i className="feather-instagram" />
                        </NavLink>
                      </div>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="sx-f-bottom-section">
          <div className="sx-f-social">
            <ul>
              <li>
                <a href="https://www.facebook.com/share/1C9iU3qFcT/">
                  <i className="flaticon-facebook" />
                </a>
              </li>
              {/* <li>
                <a
                  target="blank"
                  href="https://www.youtube.com/channel/UCFrju2gA6JeAqfZP_HWlwDQ"
                >
                  <i className="flaticon-youtube" />
                </a>
              </li> */}
              <li>
                <a href="https://www.linkedin.com/in/darch-tech-7b6535394?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
                  <i className="flaticon-linkedin" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/darch.tech?igsh=MWF3NzBjbjdhMzJvaA%3D%3D&utm_source=qr">
                  <i className="flaticon-instagram" />
                </a>
              </li>
            </ul>
          </div>
          <div className="sx-f-copy">
            © 2025 by <NavLink to="/">DArch Tech</NavLink> All rights reserved.
          </div>
        </div>
        {/* FOOTER COPYRIGHT */}
      </footer>
    </>
  );
}

export default Footer;
